// region imports
import {useContext, useEffect, useMemo} from "react";
import {Outlet,  useSearchParams} from "react-router-dom";
import {observer} from "mobx-react";
import {StoreContext} from "../../store";
import StudentViewModel from "../../view_models/students/student_view_model";
// endregion

// region ProfessorsView
// this page is the home, the professors here can see every feature available for them.
const StudentView = observer(({viewModel} : { viewModel: StudentViewModel }) => {
    // region render
    return (
        <Outlet context={viewModel} />
    )
    // endregion
});
// endregion

// region export
export default function Students() {
    // const notificationsContext = useNotifications()
    const store = useContext(StoreContext);
    // const [searchParams] = useSearchParams()
    const viewModel = useMemo(() =>
            new StudentViewModel(store),
        [store]);
    useEffect(() => {
        viewModel.onInitialized();
    }, [viewModel]);
    return <StudentView viewModel={viewModel} />
}
// endregion